import React from "react";

function roundOff(value, decimals = 2) {
  return Number(Math.round(value + "e" + decimals) + "e-" + decimals).toFixed(
    decimals
  );
}

function Utils() {
  return <div></div>;
}

export { roundOff };
export default Utils;
